module.exports = __webpack_public_path__ + "static/media/july-white.6ea202ef.svg";